import {
    Button,
    Drawer,
    Grid,
    InputAdornment
} from '@material-ui/core';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import * as logger from '../../../../logger';
import { getWalletBalance } from "../../../../store/actions/fastagActionCreators";
import { updateChatView } from "../../../../store/actions/userActionCreators";
import { rechargeFuelCard } from "../../../../store/actions/vehicleActionCreator";
import { checkNumberOnly, numberFormat, numberWithCommas, removeNumberCommas,replaceCommas } from '../../../../utils/utils';
import { SideBarDialogActions, SideBarDialogContent, SideBarDialogTitle } from '../../Dialog/Dialog';
import AmountInput from '../../Inputs/AmountInput';
import { RechargeSideBarCss as useStyles } from './RechargeSideBarCss';
import DwebPaymentGateWayDialog from '../../Dialog/DwebPaymentGateWayDialog';

const DieselCardRechargeSideBar = ({ rightSideBarOpen, truckInfo, dispatchGetWalletBalance, dispatchChatView, fastag, user, onClose, dispatchRechargeFuelCard, redirectTo, defaultAmount, fromFlow }) => {

    let submit;

    const [sideBarOpen, setSideBarOpen] = useState(rightSideBarOpen);
    const [rechargeAmountValue, setRechargeAmountValue] = useState(defaultAmount ? defaultAmount : numberWithCommas(2000));
    const [payDisabled, setPayDisabled] = useState(true);
    const [payAmount, setPayAmount] = useState(defaultAmount && truckInfo && truckInfo.isGoodsVehicle ? defaultAmount : 0);
    const [dieselCardConfig, setDieselCardConfig] = useState({});

      //Payment GateWay
  const [customPGOpen, setCustomPGOpen] = useState(false);
  const [cashFreeOrderData,setCashFreeOrderData] = useState(null);
  const [orderRequestData,setOrderRequestData] = useState(null);

    const classes = useStyles()

    const initialValues = {
        rechargeAmount: rechargeAmountValue
    }

    useEffect(() => {

        dispatchChatView(false);

        dispatchGetWalletBalance(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Diesel Card Recharge SideBar Dweb", "Get wallet amount successfull");
                }
            },
            () => {
                logger.log("Diesel Card Recharge SideBar Dweb", "Get wallet amount failed");
            }
        )

    }, []);

    useEffect(() => {

        if (user && user.fuelCardConfig) {
            setDieselCardConfig(user.fuelCardConfig)
        }

    }, [user.fuelCardConfig]);

    const getFormFields = values => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div>
                        <div className={classes.titleV1}>Recharge Amount</div>
                        <AmountInput
                            placeholder='Enter Amount*'
                            name="rechargeAmount"
                            variant="outlined"
                            size="small"
                            defaultAttribute="0"
                            onChange={(e) => {
                                setRechargeAmountValue((e.target.value).trim() ? (e.target.value).trim() : 0)
                            }}
                            fieldProps={{
                                parse: value => value && (value.trim()).length == 0 ? value.trim() : numberWithCommas(value)
                            }}
                            required={true}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">₹</InputAdornment>
                            }}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            }
        ]
    }

    const validate = values => {
        const errors = {}

        const amount = values && values.rechargeAmount ? removeNumberCommas(values.rechargeAmount) : 0;
        const checkAmount = checkNumberOnly(amount)

        // ************************* Reusing exisitng /rewards/amount API in fastag to fetch wallet balance*************************
        const walletAmount = fastag && fastag.walletBalance ? parseFloat(fastag.walletBalance).toFixed(2) : 0;

        if (!amount || amount == 0 || !checkAmount) {
            errors.rechargeAmount = "Enter valid amount."
        }

        if (amount && amount != 0 && checkAmount) {
            setPayDisabled(false)
        } else {
            setPayDisabled(true)
        }

        if (truckInfo && truckInfo.isGoodsVehicle) {
            if (walletAmount >= parseInt(amount)) {
                setPayAmount(0)
            } else {
                setPayAmount(parseInt(amount) - walletAmount)
            }
        } else {
            setPayAmount(amount);
        }

        return errors
    }

    const onSubmit = values => {

        if (!payDisabled && payAmount >= 0) {
            const rechargeAmount = values && values.rechargeAmount ? removeNumberCommas(values.rechargeAmount) : 0;
            let redirectionUrl = window.location.href;
            let brokerIdValue;
            const vehicleIdValue = truckInfo && truckInfo.vehicleId ? truckInfo.vehicleId : ""

            if (truckInfo && truckInfo.fuelCardBrokerId) {
                brokerIdValue = truckInfo.fuelCardBrokerId
            } else if (truckInfo && truckInfo.fuelBrokerId) {
                brokerIdValue = truckInfo.fuelBrokerId
            }

            // ********************************** Redirecting to single diesel card **********************************
            if (fromFlow == "dieselCard") {
                redirectionUrl = (process.env.REACT_APP_URL).trim() + `/diesel-card/single-diesel-card/${vehicleIdValue}/${brokerIdValue}`
            }

            const rechargeRequest = {
                amount: rechargeAmount,
                brokerId: brokerIdValue,
                vehicleId: vehicleIdValue ? vehicleIdValue : "",
                paymentView: 'web_v2',
                returnUrl: redirectionUrl
            }

            dispatchRechargeFuelCard(rechargeRequest,
                (data) => {
                    let rewardAmountUsed = data && data.response && data.response.rewardAmountUsed?data.response.rewardAmountUsed:null 
                    if (rewardAmountUsed && Number(rewardAmountUsed) !=0) {
                        let realAmount =  Number(replaceCommas(rechargeAmount)) - rewardAmountUsed;
                        if(realAmount>0){
                            setOrderRequestData({
                                ...rechargeRequest,
                                orderAmount: realAmount,
                                payeeType:'FUEL_CARD',
                                //finalBank:finalBank[0],
                                truckInfo:truckInfo,
                                returnUrl: redirectionUrl
                            });
                            setCashFreeOrderData(data.response);
                            setCustomPGOpen(true)
                        }else{
                            window.location.href = redirectionUrl+`?rewardAmountUsed=${data.response.rewardAmountUsed}`
                        }
                    }else if (data && data.status && data.status.code == 200 && data.response && data.response.orderAmount) {
                        setOrderRequestData({
                          ...rechargeRequest,
                          orderAmount: Number(replaceCommas(data.response.orderAmount)),
                          payeeType:'FUEL_CARD',
                          //finalBank:finalBank[0],
                          truckInfo:truckInfo,
                          returnUrl: redirectionUrl
                        });
                        setCashFreeOrderData(data.response);
                        setCustomPGOpen(true)
                        //handleClose(true)
                    }else{
                      handleClose(true)
                    }
                    /*if (data && data.status && data.status.code == 200 && data.response) {
                        logger.log("Recharge diesel card sidebar Dweb", "Recharge diesel card successfull");
                        if (data.response.paymentLink) {
                            window.location.href = data && data.response && data.response.paymentLink ? data.response.paymentLink : "";
                        }else if (data.response.rewardAmountUsed && Number(data.response.rewardAmountUsed) !=0) {
                            window.location.href = redirectionUrl+`?rewardAmountUsed=${data.response.rewardAmountUsed}`
                        } else {
                            handleClose();
                        }
                    }*/
                },
                () => {
                    logger.log("Recharge diesel card sidebar Dweb", "Recharge diesel card failed");
                }
            )
        }

    }
    const handleCustomPGClose = () => {
        setCustomPGOpen(false);
        setOrderRequestData(null);
        setCashFreeOrderData(null);
        //handleClose(true)
        dispatchGetWalletBalance(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Diesel Card Recharge SideBar Dweb", "Get wallet amount successfull");
                }
            },
            () => {
                logger.log("Diesel Card Recharge SideBar Dweb", "Get wallet amount failed");
            }
        )
      }
      const handleCustomPGConfirm = () => {
        setCustomPGOpen(false);
        setOrderRequestData(null);
        setCashFreeOrderData(null);
        handleClose(true)
      }
    const handleClose = () => {
        setSideBarOpen(false);
        onClose();
        dispatchChatView(true);
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={sideBarOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >

                <SideBarDialogTitle id={"right-sidebar-for-recharge-diesel-card"} siderBarType={'rechargeDieselCard'} onClose={handleClose}>
                    <div className={classes.divTitle}>
                        Recharge Fuel
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >
                    <div>
                        <Grid container direction='row' justify='space-between' className={classes.gridContainer} wrap="nowrap">
                            <Grid container direction='column'>
                                <Grid item className={classes.titleLeft}>Truck No</Grid>
                                <Grid item className={classes.gridVehicleNumber}>
                                    {
                                        truckInfo && truckInfo.vehicleNumArrayValue && truckInfo.vehicleNumArrayValue.map((truckNumber, index) => (
                                            <div className={index != 0 ? classes.mlV1 : ""}>{truckNumber}</div>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                            <Grid container direction='column'>
                                <Grid item className={classes.titleRight}>Fuel Balance</Grid>
                                <Grid item className={classes.fuelBalance}>{numberFormat(parseInt(truckInfo && truckInfo.balance ? truckInfo.balance : 0))}</Grid>
                            </Grid>
                        </Grid>

                        <div className={classes.divFormContainer}>
                            <Form
                                onSubmit={onSubmit}
                                initialValues={initialValues}
                                validate={validate}
                                id="myForm"
                                render={({ handleSubmit, form, submitting, pristine, values }) => {
                                    submit = handleSubmit
                                    return (
                                        <form onSubmit={handleSubmit} noValidate id="myForm">
                                            <Grid container alignItems="flex-start">
                                                {getFormFields(values).map((item, idx) => item.visible ? (
                                                    <Grid item xs={item.size} key={idx}>
                                                        {item.field}
                                                    </Grid>
                                                ) : null)}
                                            </Grid>
                                        </form>
                                    )
                                }}
                            />

                            {truckInfo && truckInfo.isGoodsVehicle &&
                                <div className={classes.divAlign}>
                                    <div>Reward Balance :&nbsp;<span className={classes.amountText}>{numberFormat(fastag && fastag.walletBalance ? fastag.walletBalance : 0)}</span></div>
                                    <div>Amount to Pay :&nbsp;<span className={classes.amountText}>{numberFormat(payAmount)}</span></div>
                                </div>
                            }

                        </div>
                    </div>

                    <div className={classes.listContainer}>
                        <div className={classes.divAlignV2}>
                            <div className={classes.divAlignV1}><FiberManualRecordIcon className={classes.circle} /></div>
                            <div className={classes.mlV2}>{dieselCardConfig && dieselCardConfig.listing_page_text ? dieselCardConfig.listing_page_text : ""}</div>
                        </div>
                        <div className={classes.divAlignV3}>
                            <div className={classes.divAlignV1}><FiberManualRecordIcon className={classes.circle} /></div>
                            <div className={classes.mlV2}>Fill in any Reliance Petrol Bunk</div>
                        </div>
                        <div className={classes.divAlignV3}>
                            <div className={classes.divAlignV1}><FiberManualRecordIcon className={classes.circle} /></div>
                            <div className={classes.mlV2}>Driver will get OTP to his Mobile Number</div>
                        </div>
                    </div>
                </SideBarDialogContent>

                <SideBarDialogActions className={classes.sideBarActions} >
                    {/* <Button variant="contained" fullWidth className={(payDisabled || payAmount < 0) ? classes.disableCta : classes.rechargeButton} onClick={event => submit(event)} >
                        {!truckInfo.isGoodsVehicle &&
                            `Pay  ${numberFormat(payAmount)}`
                        }
                        {truckInfo.isGoodsVehicle &&
                            <>
                                {payAmount == 0 ? "Recharge" : `Pay  ${numberFormat(payAmount)}`}
                            </>
                        }
                    </Button> */}
                </SideBarDialogActions>

            </Drawer>
            {customPGOpen && <DwebPaymentGateWayDialog open={customPGOpen} orderRequestData={orderRequestData} cashFreeOrderData={cashFreeOrderData} onClose={handleCustomPGClose} onSave={handleCustomPGConfirm} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetWalletBalance: (onSuccess, onError) => {
        dispatch(getWalletBalance(onSuccess, onError))
    },
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchRechargeFuelCard: (data, onSuccess, onError) => {
        dispatch(rechargeFuelCard(data, onSuccess, onError))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(DieselCardRechargeSideBar)
